"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _reactCssTransitionReplace = _interopRequireDefault(require("react-css-transition-replace"));

var _reactHammerjs = _interopRequireDefault(require("react-hammerjs"));

var _classnames = _interopRequireDefault(require("classnames"));

var _carousel = _interopRequireDefault(require("./carousel"));

require("./nav-carousel.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * NavCarousel is a specialization of Carousel, but displaying named navigation buttons
 * above the sections.
 * The name in the navigation is the Title of the section, and then titles are hidden in
 * the contained sections to avoid weird duplication. The title hiding mechanism depends
 * on headerClass being configurable via component props.
 */
var NavCarousel = /*#__PURE__*/function (_Carousel) {
  _inherits(NavCarousel, _Carousel);

  var _super = _createSuper(NavCarousel);

  function NavCarousel(props) {
    var _this;

    _classCallCheck(this, NavCarousel);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleSwipe", function (event) {
      // react-hammerjs doesn't expose these constants as far as I can tell.
      if (event.direction === 2) {
        _this.moveBack();
      } else if (event.direction === 4) {
        _this.moveForward();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setHammerRef", function (hammer) {
      // on Hammer component mount
      if (hammer && hammer.domElement) {
        _this.navDiv = hammer.domElement;

        _this.navDiv.addEventListener('scroll', _this.updateScrollIndicators);

        _this.updateScrollIndicators();
      } // on Hammer component unmount


      if (!hammer && _this.navDiv) {
        _this.navDiv.removeEventListener('scroll', _this.updateScrollIndicators);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "bindMoveTo", function (index) {
      return function () {
        return _this.move(index);
      };
    });

    _this.updateScrollIndicators = _this.updateScrollIndicators.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(NavCarousel, [{
    key: "updateScrollIndicators",
    value: function updateScrollIndicators() {
      // You cannot get a reference to navDiv directly because Hammer component overrides ref
      if (this.navDiv) {
        this.setState({
          contentLeft: this.navDiv.scrollLeft > 0,
          contentRight: this.navDiv.scrollLeft < this.navDiv.scrollWidth - this.navDiv.offsetWidth
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.updateScrollIndicators);
      this.updateScrollIndicators();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateScrollIndicators);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var currentButton = this.navButtonRefs && this.navButtonRefs[this.state.viewedIndex];

      if (currentButton && this.navDiv) {
        // This would be the perfect solution, but does not work in Safari
        // currentButton.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        // Instead, make sure the current selected button is scrolled into view if it changed
        if (this.state.viewedIndex !== prevState.viewedIndex) {
          // You cannot get a reference to navDiv directly because Hammer component overrides ref
          var currentButtonCenter = currentButton.offsetLeft + currentButton.offsetWidth / 2;
          this.navDiv.scrollLeft = currentButtonCenter - this.navDiv.offsetWidth / 2;
          this.updateScrollIndicators();
        }
      }
    }
    /**
     * Bind MoveTo function to specific index.
     * Returns a function bound to a specific index.
     */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var visibleChild = this.props.children[this.state.viewedIndex];
      this.navButtonRefs = []; // if the child component is using backgroundStyleClass in the section, then
      // the title is hidden within a wrapper, which can't have headerClass set on it.
      // TODO: STORE-2587 rewrite how backgroundStyleClass is handled for improved composablity

      if (visibleChild.type !== 'div') {
        // Override headerClass so we can hide it.
        visibleChild = /*#__PURE__*/_react["default"].cloneElement(visibleChild, {
          headerClass: 'subsection-header'
        });
      }

      var navigationButtons = [];

      for (var i = 0; i < this.props.children.length; i += 1) {
        var title = _lodash["default"].get(this.props, ['children', i, 'props', 'title']); // if the child component is using backgroundStyleClass in the section, then
        // the title is hidden within a wrapper


        if (!title) {
          title = _lodash["default"].get(this.props, ['children', i, 'props', 'children', 'props', 'title']);
        } // For widget system, Contentful fields are passed via model rather than spread to children.


        if (!title) {
          title = _lodash["default"].get(this.props, ['children', i, 'props', 'model', 'fields', 'title']);
        }

        navigationButtons.push( /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          ref: function ref(button) {
            return button && _this2.navButtonRefs.push(button);
          },
          key: "nav-".concat(i),
          onClick: this.bindMoveTo(i),
          className: "medium ".concat(this.state.viewedIndex === i ? 'selected' : '')
        }, title));
      }

      var navClasses = (0, _classnames["default"])('navWrapper', {
        contentLeft: this.state.contentLeft,
        contentRight: this.state.contentRight
      }); // Unfortunately, Hammerjs doesn't seem to expose 'DIRECTION_HORIZONTAL' constants

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "NavCarousel"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: navClasses
      }, /*#__PURE__*/_react["default"].createElement(_reactHammerjs["default"], {
        onSwipe: this.handleSwipe,
        direction: "DIRECTION_HORIZONTAL",
        ref: this.setHammerRef
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "navigation"
      }, navigationButtons))), /*#__PURE__*/_react["default"].createElement(_reactCssTransitionReplace["default"], {
        transitionName: "fade-wait",
        transitionEnterTimeout: 300,
        transitionLeaveTimeout: 300
      }, visibleChild));
    }
  }]);

  return NavCarousel;
}(_carousel["default"]);

NavCarousel.propTypes = {
  children: _propTypes["default"].arrayOf(_propTypes["default"].node).isRequired
};
var _default = NavCarousel;
exports["default"] = _default;